export default "__VITE_ASSET__v1n4GQU$__"